import { AbstractControl, ValidatorFn } from '@angular/forms';

export function passwordStrengthValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value || '';

    // Regular expressions to match the required conditions
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
    const isValidLength = value.length >= 8 && value.length <= 20;

    // Check for validity based on all conditions
    const passwordValid =
      hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar && isValidLength;

    if (value !== '' && !passwordValid) {
        return { invalidPassword: true };
    }

    return null; // No error
  };
}
